const { render } = wp.element;

import React from 'react'
import { getElementById } from 'commonutils/compatdom'
import { Provider } from 'react-redux'
import store from 'notifications/data'
import APP from './app'

/* Render */

const init = () => {
  
  render(
    <Provider store={store}>
      <APP />
    </Provider>,
    getElementById('Page')
  )
}

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    init
  )

} else {

  init();
}